import React from 'react'
import moment from 'moment'
import 'moment-precise-range-plugin'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import {
  TYPE_INPUT_DATE_TIME,
  TYPE_INPUT_DATE,
  TYPE_INPUT_TIME,
  TYPE_INPUT_FILE,
  TYPE_INPUT_CALCULATED,
  TYPE_INPUT_NUMBER,
  TYPE_INPUT_SIGNATURE,
} from 'helpers/jobs'
import {
  getFormattedDate,
  getTimeFormat,
  getPreviewInputDateFormat,
} from 'helpers/dates'

function PreviewInputValues({
  profileInfo: { name: profileName },
  licensee: { usaDateFormat, usaTimeFormat, latinAmericanNumberFormat },
  previewList,
}) {
  const renderPreviewValue = (value, type) => {
    const formatPreview = getPreviewInputDateFormat(usaDateFormat)
    if (type === TYPE_INPUT_DATE_TIME) {
      const timeFormat = getTimeFormat(usaTimeFormat)

      return getFormattedDate(value, `${formatPreview} ${timeFormat}`)
        .toString()
        .substring(0, 16)
    }

    if (type === TYPE_INPUT_DATE) {
      return getFormattedDate(value, formatPreview).toString()
    }

    if (type === TYPE_INPUT_TIME) {
      const textValue = value.toString()

      return moment(textValue, 'HH:mm').format(getTimeFormat(usaTimeFormat))
    }

    if (type === TYPE_INPUT_FILE) {
      return (!!value).toString()
    }

    if (
      (type === TYPE_INPUT_NUMBER || type === TYPE_INPUT_CALCULATED) &&
      latinAmericanNumberFormat
    ) {
      return String(value).replace('.', ',')
    }

    if (type === TYPE_INPUT_SIGNATURE) {
      return value.name || profileName
    }

    return Object.prototype.hasOwnProperty.call(value, 'title')
      ? value.title
      : value.toString()
  }

  if (!previewList.length) {
    return ''
  }

  return (
    <div className="sf-preview-input-box">
      {previewList.map(
        ({ title: previewTitle, short_name, value, type }, index) => (
          <div key={`${previewTitle}${type}${index}`} className="preview-item">
            <span title={short_name || previewTitle} className="preview-title">
              {short_name || previewTitle}
            </span>
            {(!!value || value === false || value === 0) && (
              <span className="preview-value-text">
                {renderPreviewValue(value, type)}
              </span>
            )}
          </div>
        ),
      )}
    </div>
  )
}

export default connect(state => ({
  licensee: state.getIn(['profile', 'profile', 'licensee']),
  profileInfo: state.getIn(['profile', 'profile']),
}))(injectIntl(PreviewInputValues))
